/**
 * 地理位置服务 - 检测用户IP地址和地理位置
 */

import http from '@/api/http'

/**
 * 使用多个API检测用户的IP地址和国家/地区
 */
export async function getUserGeoLocation() {
  try {
    const response = await http.get('/auth/geo-location', { skipAuth: true })
    const data = response.data || {}
    return {
      ip: data.ip,
      country: data.country,
      country_name: data.countryName,
      region: data.region,
      city: data.city
    }
  } catch (error) {
    console.warn('Failed to get geo location:', error)
    return null
  }
}

/**
 * 检查用户是否在中国大陆
 */
export async function isChineseMainlandIP() {
  try {
    const geoData = await getUserGeoLocation()
    if (!geoData) {
      return false
    }

    // 检查国家代码是否为中国 (CN)
    return geoData.country === 'CN'
  } catch (error) {
    console.error('Failed to check IP location:', error)
    return false
  }
}

/**
 * 检查是否应该显示地理位置限制通知
 */
export async function shouldShowGeoRestriction() {
  try {
    // 检查是否在24小时内已经关闭过通知
    const lastClosed = localStorage.getItem('geo-restriction-notice-closed')
    if (lastClosed) {
      const lastClosedTime = parseInt(lastClosed, 10)
      const now = Date.now()
      const hoursSinceLastClosed = (now - lastClosedTime) / (1000 * 60 * 60)

      // 如果24小时内已经关闭过，不再显示
      if (hoursSinceLastClosed < 24) {
        return false
      }
    }

    // 检查是否为中国大陆IP
    return await isChineseMainlandIP()
  } catch (error) {
    console.error('Error checking geo restriction:', error)
    return false
  }
}

/**
 * 获取用户地理位置信息用于显示
 */
export async function getLocationDisplayInfo() {
  try {
    const geoData = await getUserGeoLocation()
    if (!geoData) {
      return '未知位置'
    }

    return `${geoData.city || ''}${geoData.region ? ', ' + geoData.region : ''}, ${geoData.country_name || geoData.country}`
  } catch (error) {
    console.error('Failed to get location display info:', error)
    return '未知位置'
  }
}
